import { render, staticRenderFns } from "./ExtractorItem.vue?vue&type=template&id=c28d8246&scoped=true"
import script from "./ExtractorItem.vue?vue&type=script&lang=ts"
export * from "./ExtractorItem.vue?vue&type=script&lang=ts"
import style0 from "./ExtractorItem.vue?vue&type=style&index=0&id=c28d8246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28d8246",
  null
  
)

export default component.exports